import React from 'react';
import { CALENDLY_DEMO_URL } from '../utils/calendly';

export function OrganizationDemoCard() {
  const handleRequestDemo = () => {
    window.open(CALENDLY_DEMO_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="plans-b-card plans-b-card--demo" data-testid="organization-demo-card">
      <div className="plans-b-card-heading">For schools &amp; organizations · custom pricing</div>
      <div className="plans-b-price">Custom</div>
      <p className="plans-b-sub">
        Whether you&apos;re supporting 50 student-athletes or 5,000, we&apos;ll build a solution that
        fits your community.
      </p>
      <p className="plans-b-note">
        One connected platform that brings together administrators, counselors, coaches, educators,
        families, and student-athletes to create a more intentional, future-ready experience. Our
        team would love to learn more about your school and recommend the right fit.
      </p>
      <button
        type="button"
        className="plans-b-btn plans-b-btn-primary"
        onClick={handleRequestDemo}
        data-testid="request-demo-btn"
      >
        Request a Demo
      </button>
    </div>
  );
}

export default OrganizationDemoCard;
